@if (getStatus | fn : value : statusMapObj) {
<div class="status-area">
  <div class="dot-icon" [style]="getStatusColorStyle | fn : value : statusMapObj"></div>
  <div>{{ getStatus | fn : value : statusMapObj | lang }}</div>
</div>
}
